import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../../common/components/SearchBox";
import { Typography, Box, Button, Menu, MenuItem } from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";

import { getPrograms } from "../../../../store/cpd/actions";

const Settings = (props) => {
  useEffect(() => {
    document.title = "TMIS | CPD - Settings";
  }, []);

  const { user, loading, programs, getPrograms } = props;

  useEffect(() => {
    getPrograms();
  }, []);

  return <div className="px-4">CPD | Archived trainings</div>;
};

const mapStateToProps = ({ user, loading, programs }) => {
  return { user, loading, programs };
};
export default connect(mapStateToProps, { getPrograms })(Settings);
